// extracted by mini-css-extract-plugin
module.exports = {"whiteStyle":"e_MG","prefix":"e_NG","counter":"e_OG"};